import type { ParseKeys } from "i18next";

import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";
import type { IApptType } from "@routes/appointment/path";

export const reportsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.visitSummaryNotes.route,
      lazy: () => import("@pages/panelPages/summaryNotes/summaryNoteListPage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.past-visit-summary-notes",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["doctor", "super-admin", "staff", "local-admin", "admin"],
  },
  {
    route: {
      path: path.doctorFinancial.route,
      lazy: () =>
        import(
          "@pages/panelPages/financialManagements/financialReports/financialReports"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.financialManagements.financialReports",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["super-admin", "admin", "local-admin"],
  },
  {
    route: {
      path: path.hfFinancial.route,
      lazy: () =>
        import(
          "@pages/panelPages/financialManagements/financialReports/financialReports"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.financialManagements.financialReports",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["super-admin", "admin", "local-admin"],
  },
  {
    route: {
      path: path.appointments.route,
      lazy: () => import("@pages/panelPages/appointment/appointmentListPage"),
      loader: async ({ request }) => {
        const type = "all" as IApptType;

        const title: ParseKeys<"common"> = "pageTitle.appointmentList";

        useUIStore.getState().setPage(request, title, [], "index", "main");
        return { type };
      },
    },
    permissions: [
      "doctor",
      "patient",
      "super-admin",
      "staff",
      "admin",
      "local-admin",
    ],
  },
  {
    route: {
      path: path.patients.route,
      lazy: () =>
        import("@pages/panelPages/userManagement/patient/patientList"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.patientManagement", [], "index", "main");
        return {};
      },
    },
    permissions: ["super-admin", "admin", "local-admin", "staff"],
  },
  {
    route: {
      path: path.doctorFinancialForDoctorPath.route,
      lazy: () =>
        import(
          "@pages/panelPages/financialManagements/financialRecords/doctorFinancialRecords"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.financialManagements.financialRecords",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["doctor"],
  },
  {
    route: {
      path: path.doctorPatientsPath.route,
      lazy: () =>
        import("@pages/panelPages/myPatients/patientsList/patientsList"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.patientsList", [], "index", "main");
        return {};
      },
    },
    permissions: ["doctor"],
  },
];
